import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import {getWebComponentInstance} from "fg-frontend/src/webComponents/decorate";

const fragments =  {
	INPUT: '[data-fragment="UpdateChargeAfterDate.input"]',
	MESSAGE: '[data-fragment="UpdateChargeAfterDate.message"]',
}

class UpdateChargeAfterDate extends WebComponent {
	constructor(props) {
		super(props);
		const {} = props;
	}

	didMount() {
		const {
		} = this.props;

		const universalPreloaderComponentElement = document.getElementById('universalPreloader');
		this.universalPreloaderComponent = getWebComponentInstance(universalPreloaderComponentElement);

		this.inputEl = this.element.querySelector(fragments.INPUT);
		this.messageEl = this.element.querySelector(fragments.MESSAGE);


		if(this.inputEl) {
			this.on('change', fragments.INPUT, (e) => {
				this.sendData(e.target.value);
			});
		}
	}

	sendData = (date) => {
		this.universalPreloaderComponent.handleOn(10);
		let dataJSON = [];
		let commitUrl = window.location.pathname + '?csrf=' + this.getCsrfToken() + this.getFormId() + '&eventName.updateChargeAfterDate';
		let xmlHttpReq = new XMLHttpRequest();
		let _self = this;
		let formattedDate = date;
		if (date && typeof date === 'string') {
			let parts = date.split('.').map(part => part.trim());
			if (parts.length === 3) {
				formattedDate = `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
			}
		}
		dataJSON = {
			orderId: Number.parseInt(_self.element.dataset.orderid),
			orderPartId: Number.parseInt(_self.element.dataset.orderpartid),
			chargeAfterDate: formattedDate,
		};
		xmlHttpReq.open('POST', commitUrl, true);
		xmlHttpReq.setRequestHeader("Content-Type", "application/json");
		xmlHttpReq.onreadystatechange = function () {
			if (xmlHttpReq.readyState === 4) {
				const formGroup = _self.inputEl.closest('.form-group');
				const errorMessages = {
					"failedToUpdateDate": "Dátum sa nepodarilo aktualizovať. Skúste to prosím neskôr.",
					"dateUpdateNotAllowed": "Zmena dátumu pre túto objednávku nie je povolená.",
					"orderIdMissing": "Vyskytla sa chyba: Chýba ID objednávky.",
					"orderPartIdMissing": "Vyskytla sa chyba: Chýba ID časti objednávky.",
					"chargeAfterDateMissing": "Prosím, zadajte dátum.",
					"chargeAfterDateMustBeInFuture": "Zvolený dátum musí byť v budúcnosti."
				};
				if (xmlHttpReq.status === 200) {
					const res = JSON.parse(xmlHttpReq.responseText);
	        		if(res['errorMessage']) {
						formGroup.classList.add('has-error');
						_self.messageEl.innerHTML = errorMessages[res['errorMessage']] || errorMessages['failedToUpdateDate'];
					} else {
						formGroup.classList.remove('has-error');
						_self.messageEl.innerHTML = '';
					}
				} else {
					formGroup.classList.add('has-error');
					_self.messageEl.innerHTML = errorMessages['failedToUpdateDate'];
				}
				_self.universalPreloaderComponent.handleOff(10);
			}
		};
		xmlHttpReq.send(JSON.stringify(dataJSON));
	}

	getCsrfToken = () => {
		return document.querySelector('form input[name=csrf]').value;
	};

	getFormId = () => {
		let formId = document.querySelector('form input[name=formId]');
		if(formId) {
			return '&formId=' + formId.value;
		}
		return '';
	};
}
export default UpdateChargeAfterDate;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Admin/UpdateChargeAfterDate.js